import { api } from '../../../modules/common-utils-services/axiosUtil';
import endpoints from '../../../constants/configs/endpoints';
import { ADMIN_SERFF_TRANSFER_STATUS_ACTION_TYPES } from '../../../constants/actionTypes/adminSerffStatusActionTypes';

export const setTransferStatusDataList = (data) => ({
    type: ADMIN_SERFF_TRANSFER_STATUS_ACTION_TYPES.SET_TRANSFER_STATUS_DATA,
    payload: data,
});

export const setTransferPlanAttachmentsList = (data) => ({
    type: ADMIN_SERFF_TRANSFER_STATUS_ACTION_TYPES.SET_TRANSFER_STATUS_DATA,
    payload: data,
});

/**
 * Fetch Plan Load Status Data List with optional filters
 * @param filters - Optional filters object containing selectedIssuer, selectedType, selectedStatus, and dateRange
 */
export const fetchSerffTransferStatusDataList = filters => async dispatch => {
    const { issuerFilter, statusFilter, dateFilter, page, size } = filters || {};

    const url = endpoints.ADMIN_SERFF_GET_TRANSFER_STATUS_DATA_LIST.processReplacements({
        issuerFilter: issuerFilter,
        statusFilter: statusFilter,
        dateFilter: dateFilter,
        page: page,
        size: size,
    });

    try {
        const { data } = await api.get(url);

        if (!data) {
            console.warn('⚠️ No data returned for SERFF Transfer Status request');
        }
        dispatch(setTransferStatusDataList(data));
    } catch (error) {
        console.error('Error fetching Transfer Status Data:', error);
    }
};

export const fetchSerffPlanAttachmentsList = filters => async dispatch => {
    const { issuerFilter, statusFilter, dateFilter, page, size } = filters || {};

    const url = endpoints.ADMIN_SERFF_PLAN_ATTACHMENTS_LIST.processReplacements({
        issuerFilter: issuerFilter,
        statusFilter: statusFilter,
        dateFilter: dateFilter,
        page: page,
        size: size,
    });

    try {
        const { data } = await api.get(url);

        if (!data) {
            console.warn('⚠️ No data returned for SERFF Transfer Status request');
        }
        dispatch(setTransferStatusDataList(data));
    } catch (error) {
        console.error('Error fetching Transfer Status Data:', error);
    }
};